import React, { Dispatch, SetStateAction } from 'react';
import { FlatList, StyleSheet } from 'react-native';
import TargetCard from './components/TargetCard';
import { ChartDataPoint } from '../../../../graphs/axisUtils';

export type TargetCardItem = {
  title: string,
  unit: string,
  target: number,
  total: number,
  data: ChartDataPoint[] | null,
}

interface MobileOverviewProps {
  items: TargetCardItem[],
  setSelectedMetricIndex: Dispatch<SetStateAction<number>>,
}

const MobileOverview = ({ items, setSelectedMetricIndex }: MobileOverviewProps) => <FlatList
  style={styles.container}
  data={items}
  renderItem={({ item, index }) => <TargetCard
    {...item}
    showGraph={() => setSelectedMetricIndex(index)}
  />}
  keyExtractor={(item: TargetCardItem) => `target_card_item_${item.title}`}
/>;

const styles = StyleSheet.create({
  container: {
    marginHorizontal: -24,
    paddingHorizontal: 24,
  },
});

export default MobileOverview;
